import { postApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_reactions'

type Operation = operations['messenger_add_reaction_to_message_addReaction']
type Response = Operation['responses']['204']
type Body = Operation['parameters']['body']['body']

export const addReactionApi = (messageUuid: string, reactionId: number) => {
  return postApi<Response, Body>(
    `/messages/${messageUuid}/reactions` as '/messages/{messageId}/reactions',
    { messageId: messageUuid, reactionId }
  )
}
